import React from 'react';
import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/styles';
import { useWaitlistRanksQuery, WaitlistType } from '../../gqlReactTypings.generated.d';
import { useGraphqlErrorNotification } from '../../shared/hooks/useGraphqlErrorNotification';
import { WaitlistRankCard } from './WaitlistRankCard';

const CardContainer = styled.div<React.PropsWithChildren<{ waitlistCount?: number }>>`
  display: flex;
  justify-content: ${(props) => (props.waitlistCount && props.waitlistCount > 1 ? 'left' : 'center')};
  gap: 30px;
  flex-direction: row;
  max-width: 800px;
  width: 100%;
  margin: 0px auto;
  height: 81px;

  @media (max-width: ${ScreenWidth.SMALL}) {
    justify-content: space-evenly;
    flex-direction: column;
    min-height: 100px;
    height: 100%;
    gap: 10px;
  }
`;

const EmptyContainer = CardContainer; // So we don't have jitter as it loads

export const WaitlistRankOverview: React.FC = () => {
  const { data, error, loading } = useWaitlistRanksQuery({ fetchPolicy: 'cache-and-network' });

  useGraphqlErrorNotification(error);

  if (loading) {
    return <EmptyContainer />;
  }

  if (!data?.waitlistRanks.length) {
    console.error(`No waitlistRanks found!`);
    return <EmptyContainer />;
  }

  const consumerRank = data.waitlistRanks.find((w) => w.waitlistType === WaitlistType.Consumer);
  const shefRank = data.waitlistRanks.find((w) => w.waitlistType === WaitlistType.Shef);

  const waitlistCount = [!!consumerRank, !!shefRank].filter(Boolean).length;
  return (
    <CardContainer waitlistCount={waitlistCount}>
      {consumerRank && (
        <WaitlistRankCard
          rank={consumerRank.rank}
          type={WaitlistType.Consumer}
          numBehind={consumerRank.totalUsers - consumerRank.rank}
        />
      )}
      {shefRank && (
        <WaitlistRankCard // quick hard-coding for now to make it seem more appealing to shefs
          rank={Math.min(48, shefRank.rank)}
          type={WaitlistType.Shef}
          numBehind={Math.min(156, shefRank.totalUsers - shefRank.rank)}
        />
      )}
    </CardContainer>
  );
};
